import { Currency, Meal, Dietary, Allergen, CcOrderSource } from '@/generated/gql/graphql'

import { AxiosPromise } from 'axios'
import qs from 'qs'

import { clientV2, clientV21 } from './base'
import { Response } from './types'

export type OrderItem = {
  id: string
  name: string
  qty: number
  reference?: string
  item: {
    id: string
    name: string
    price: string
    image: string
    description: string
    dietaries: Dietary[]
    allergens: Allergen[]
  }
  options: {
    id: string
    name: string
    price: string
  }[]
}

export type VendorGroup = {
  vendor: {
    id: string
    companyName: string
  }
  items: OrderItem[]
  supplierOrder?: {
    id: string
    reference: string
    arrivalTime: string
    duration: number
  }
}

export type OrderDetails = {
  hidePrices: boolean
  reference: string
  date: string
  timeSlot: {
    start: string
    end: string
  }
  meal: Meal
  address: {
    line1: string
    line2: string
    city: string
    postcode: string
    location: string
  }
  subsidyCreditsUsed: number
  personalCreditsUsed: number
  subtotal: number
  total: number
  currency: Currency
  items: OrderItem[]
  itemsByVendor?: VendorGroup[]
  timezone: string
}

export const clientInitiateCcOrder = (
  amount: string | number,
  bundle: number,
  date: string | Date,
  meal: string,
  items: unknown[],
  arrivalTime: string | Date,
  currency: Currency,
  orderCodes: { code: string; value: string }[],
): AxiosPromise<Response<{ authToken: string }>> =>
  clientV2.post('/initiateCcOrder', {
    amount,
    bundle,
    date,
    meal,
    items,
    arrivalTime,
    currency,
    orderCodes,
    orderSource: CcOrderSource.Web,
  })

export const ccPlaceOrder21 = async (
  date: string | Date,
  meal: string,
  items: unknown[],
  arrivalTime: string | Date,
  orderCodes: { code: string; value: string }[],
  language: string,
) =>
  clientV21.post(`/ccOrderItems?${qs.stringify({ language })}`, {
    payment: {},
    amount: 0,
    bundle: 0,
    date,
    meal,
    items,
    arrivalTime,
    orderCodes,
    respondAsObject: true,
    orderSource: CcOrderSource.Web,
  })

export const ccDashboardCancelOrder = async (id: number | string) =>
  clientV2.delete(`/dashboard/orders/${id}`)
